import type { DateRangeOption, DateRangeOptionValue, PreviousYearSegmentOption } from "./types";

/**
 * Canonical option list in the order they should appear in dropdowns.
 *
 * This is the single source of truth referenced by `getCanonicalOptions` and
 * every consumer of the standardized filter.
 */
export const CANONICAL_OPTIONS: readonly DateRangeOption[] = [
  { label: "All Time", value: "all_time" },
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "This Week", value: "this_week" },
  { label: "Last Week", value: "last_week" },
  { label: "Last 7 Days", value: "last_7_days" },
  { label: "Last 14 Days", value: "last_14_days" },
  { label: "Last 30 Days", value: "last_30_days" },
  { label: "Last 90 Days", value: "last_90_days" },
  { label: "This Month", value: "this_month" },
  { label: "Last Month", value: "last_month" },
  { label: "This Quarter", value: "this_quarter" },
  { label: "Last Quarter", value: "last_quarter" },
  { label: "This Year", value: "this_year" },
  { label: "Last Year", value: "last_year" },
  { label: "Custom", value: "custom" },
];

/**
 * Lookup of option value -> display label. Useful for rendering selected values
 * outside the dropdown.
 */
export const OPTION_LABEL_BY_VALUE: Readonly<Record<DateRangeOptionValue, string>> =
  CANONICAL_OPTIONS.reduce(
    (acc, { label, value }) => {
      acc[value] = label;
      return acc;
    },
    {} as Record<DateRangeOptionValue, string>,
  );

/**
 * Previous-year segments in display order: twelve months followed by four quarters.
 */
export const PREVIOUS_YEAR_SEGMENTS: readonly PreviousYearSegmentOption[] = [
  { label: "January", value: "january" },
  { label: "February", value: "february" },
  { label: "March", value: "march" },
  { label: "April", value: "april" },
  { label: "May", value: "may" },
  { label: "June", value: "june" },
  { label: "July", value: "july" },
  { label: "August", value: "august" },
  { label: "September", value: "september" },
  { label: "October", value: "october" },
  { label: "November", value: "november" },
  { label: "December", value: "december" },
  { label: "Q1", value: "q1" },
  { label: "Q2", value: "q2" },
  { label: "Q3", value: "q3" },
  { label: "Q4", value: "q4" },
];
